// extracted by mini-css-extract-plugin
export default {"account":"delete-account_account__nNm6p","menu":"delete-account_menu__aLJP-"};